// A small, deterministic placeholder for reports whose real screenshot
// hasn't generated yet. The colour is hashed from the client + report slug
// so the same report always gets the same placeholder, and consultants can
// tell rows apart even pre-thumbnail.

import { escapeHtml } from "../chrome";

const PALETTES: Array<[string, string]> = [
  ["#1a2e4d", "#006EEE"], // navy → TFG blue
  ["#2a1845", "#6b3bb7"], // deep purple
  ["#3a2410", "#C9A84C"], // dark amber → gold
  ["#0f3a2c", "#27c19a"], // forest → mint
  ["#3a1218", "#e84a5f"], // burgundy → coral
  ["#0a2d3d", "#4ab9c9"], // navy → teal
  ["#2a2a0a", "#c9b830"], // olive → mustard
];

function hash(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h = (h ^ s.charCodeAt(i)) * 16777619;
  }
  return Math.abs(h);
}

export function renderThumbnail(args: {
  thumbnailUrl: string | undefined;
  clientSlug: string;
  reportSlug: string;
}): string {
  const { thumbnailUrl, clientSlug, reportSlug } = args;

  if (thumbnailUrl) {
    return `
      <img src="${escapeHtml(thumbnailUrl)}"
           class="block w-20 h-[3.4rem] object-cover rounded border border-ink-border bg-ink-surface"
           loading="lazy" alt="" />
    `;
  }

  // Deterministic gradient placeholder until the thumbnail Lambda finishes.
  const palette = PALETTES[hash(`${clientSlug}/${reportSlug}`) % PALETTES.length]!;
  const initials = (clientSlug[0] ?? "").toUpperCase();

  return `
    <div class="w-20 h-[3.4rem] rounded border border-ink-border flex items-center justify-center
                relative overflow-hidden"
         style="background: linear-gradient(135deg, ${palette[0]} 0%, ${palette[1]} 100%);"
         aria-hidden="true">
      <span class="text-xs font-mono font-semibold text-white/60 tracking-wider">${escapeHtml(initials)}</span>
      <span class="absolute inset-x-0 bottom-0 text-[8px] font-mono uppercase text-white/40 text-center pb-0.5 tracking-wider">
        Generating…
      </span>
    </div>
  `;
}
